export { default as default } from './ErrorBoundary';
